module.exports = __webpack_public_path__ + "img/maker-7.ccb2f52e.jpg";